import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { ToastContainer } from "react-toastify";
import logo from "../../assets/login/yobase.jfif";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const result = await login(email, password);
    if(!result.isError){
      navigate("/");
    }else {
      setError(result?.error?.message === "Network Error" ? "Some thing went wrong!" : (result?.error?.response?.data?.message || 'Check your credential please'));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="layout-1">
      <div className="wrapper">
        <ToastContainer />
        <div className="page-body auth yobas-auth-page px-xl-4 px-sm-3 px-2 py-lg-4 py-3">
          <div className="container-fluid">
            <div className="row align-items-center justify-content-center g-4 g-xl-5">
              <div className="col-lg-6 d-none d-lg-flex justify-content-center">
                <div className="yobas-auth-brand">
                  <img
                    src={logo}
                    alt="YouBas Autopilot"
                    className="yobas-auth-brand__logo"
                  />
                  <h1 className="yobas-auth-brand__title">YouBas Autopilot</h1>
                  <p className="yobas-auth-brand__text">
                    Simplifies daily operations with automated warehouse,
                    inventory, and approval management.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 d-flex justify-content-center align-items-center">
                <div className="yobas-auth-card w-100">
                  <div className="text-center">
                    <img
                      src={logo}
                      alt="YouBas Autopilot"
                      className="yobas-auth-card__logo"
                    />
                  </div>
                  <div
                    className="card shadow-sm w-100 p-4 p-md-5 yobas-auth-form-card"
                    style={{ maxWidth: "32rem" }}
                  >
                    <form className="row g-3" onSubmit={handleSubmit}>
                      <div className="col-12 text-center mb-5">
                        <h1>Sign in</h1>
                      </div>
                      {error && (
                        <div className="col-12 text-center">
                          <span className="text-danger">{error}</span>
                        </div>
                      )}
                      <div className="col-12">
                        <div className="mb-2">
                          <label className="form-label">Email address</label>
                          <input
                            type="email"
                            className="form-control form-control-lg"
                            placeholder="name@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="mb-2">
                          <div className="input-group">
                            <input
                              id="password"
                              className="form-control form-control-lg"
                              type={showPassword ? "text" : "password"}
                              placeholder="Enter the password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                            <div
                              className="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={togglePasswordVisibility}
                              >
                                {showPassword ? (
                                  <i
                                    className="fa fa-eye-slash"
                                    aria-hidden="true"
                                  ></i>
                                ) : (
                                  <i className="fa fa-eye" aria-hidden="true"></i>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-lg btn-block lift text-uppercase"
                          style={{background:"#2016c1", color:'white', width:"100%"}}
                        >
                          SIGN IN
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
